import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getFormattedCurrentTime } from '../../utils/helper';
import styles from '@dtsl/css-timepicker/dist/index.module.css';
import { Button } from '@dtsl/react/dist/components/Button';
import { Chip } from '@dtsl/react/dist/components/Chip';
const Footer = _ref => {
  let {
    onConfirm,
    onNow,
    nowLabel,
    okLabel,
    minuteInterval,
    onChange,
    setIsFloatingPanelVisible
  } = _ref;
  const footerClasses = classNames({
    [styles['sib-timpicker-footer']]: true
  });
  const onNowClick = () => {
    let currentTime = getFormattedCurrentTime(minuteInterval);
    onChange(currentTime);
    onNow(currentTime);
  };
  const onOkayClick = () => {
    setIsFloatingPanelVisible(false);
    onConfirm();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: footerClasses,
    "data-testId": "timepicker-footer"
  }, /*#__PURE__*/React.createElement(Chip, {
    label: nowLabel || 'Now',
    dataTest: "now-button-id",
    id: "now-button-id",
    "data-testId": "now-button-id",
    onClick: onNowClick
  }), /*#__PURE__*/React.createElement(Button, {
    label: okLabel || 'OK',
    variant: "secondary",
    dataTest: "ok-button-id",
    "data-testId": "ok-button-id",
    onClick: onOkayClick
  }));
};
Footer.propTypes = {
  onConfirm: PropTypes.func,
  onNow: PropTypes.func,
  nowLabel: PropTypes.string,
  okLabel: PropTypes.string,
  minuteInterval: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  setIsFloatingPanelVisible: PropTypes.func.isRequired
};
export default Footer;